import { FiChevronDown } from '@react-icons/all-files/fi/FiChevronDown'
import { FiChevronLeft } from '@react-icons/all-files/fi/FiChevronLeft'
import { FiChevronRight } from '@react-icons/all-files/fi/FiChevronRight'
import { FiChevronUp } from '@react-icons/all-files/fi/FiChevronUp'

// previous/next, left/right, expand/collapse, up/down,

export const IconChevronUp = FiChevronUp
export const IconChevronDown = FiChevronDown
export const IconGoBack = FiChevronLeft
export const IconChevronLeft = FiChevronLeft
export const IconChevronRight = FiChevronRight
